(() => {
  'use strict';
  const normalizeQuantity = value => {
    const number = Math.floor(Number(value));
    return Number.isSafeInteger(number) && number > 0 ? String(number) : '1';
  };
  const setupQuoteLinks = () => {
    document.querySelectorAll('[data-ultrapoe-quantity-quote]').forEach(link => {
      if (link.dataset.quoteReady) return;
      const form = document.getElementById(link.dataset.formId);
      if (!form) return;
      let variants;
      try { variants = JSON.parse(link.dataset.variants); } catch (_) { return; }
      if (!Array.isArray(variants)) return;
      link.dataset.quoteReady = 'true';
      const updateLink = () => {
        const selector = form.querySelector('[name="id"]');
        const selectedId = selector ? selector.value : '';
        const selectedOptions = Array.from(form.querySelectorAll('.single-option-selector')).map(input => input.value);
        const currentUrl = new URL(window.location.href);
        const variant = variants.find(item => String(item.id) === selectedId)
          || (selectedOptions.length && variants.find(item => Array.isArray(item.options) && item.options.length === selectedOptions.length && item.options.every((option, index) => option === selectedOptions[index])))
          || variants.find(item => String(item.id) === currentUrl.searchParams.get('variant'))
          || variants.find(item => String(item.id) === link.dataset.defaultVariant);
        const quantity = form.querySelector('[name="quantity"]');
        const target = new URL(link.href, window.location.origin);
        target.searchParams.set('uq', '1');
        target.searchParams.set('uq_product', link.dataset.productTitle);
        target.searchParams.set('uq_quantity', normalizeQuantity(quantity ? quantity.value : 1));
        target.searchParams.set('uq_path', link.dataset.productPath);
        target.searchParams.set('uq_variant', variant ? variant.title : '');
        target.searchParams.set('uq_sku', variant ? variant.sku || '' : '');
        target.searchParams.set('uq_variant_id', variant ? String(variant.id) : '');
        const preview = currentUrl.searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
        target.hash = 'WholesaleInquiryForm';
        link.href = target.href;
      };
      ['click', 'auxclick', 'contextmenu', 'pointerdown', 'focus'].forEach(event => link.addEventListener(event, updateLink));
      ['input', 'change'].forEach(event => form.addEventListener(event, () => queueMicrotask(updateLink)));
      window.addEventListener('pageshow', updateLink);
      updateLink();
    });
  };
  const prefillInquiry = () => {
    const form = document.getElementById('WholesaleInquiryForm');
    if (!form || form.dataset.quotePrefilled) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('uq') !== '1') return;
    const product = (params.get('uq_product') || '').trim().slice(0, 500);
    const productInput = form.elements.namedItem('contact[Product 1]');
    const quantityInput = form.elements.namedItem('contact[Quantity 1]');
    if (!product || !productInput || !quantityInput || productInput.value || quantityInput.value) return;
    const variant = (params.get('uq_variant') || '').trim().slice(0, 250);
    const sku = (params.get('uq_sku') || '').trim().slice(0, 250);
    productInput.value = product + (variant && variant !== 'Default Title' ? ' / ' + variant : '');
    quantityInput.value = normalizeQuantity(params.get('uq_quantity'));
    form.dataset.quotePrefilled = 'true';
    const metadata = { 'Product SKU': sku, 'Product variant ID': (params.get('uq_variant_id') || '').replace(/[^0-9]/g, '').slice(0, 25) };
    const path = params.get('uq_path') || '';
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(path)) metadata['Product URL'] = new URL(path, window.location.origin).href;
    Object.entries(metadata).forEach(([name, value]) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + name + ']';
      input.value = value;
      form.appendChild(input);
    });
    [productInput, quantityInput].forEach(input => {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  const initialize = () => { setupQuoteLinks(); prefillInquiry(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
